<div class="layout">
  <mat-card class="form-card layout-main" [formGroup]="formPack">
    <div *ngIf="!isEdit; else editTemplate">
      <mat-card-content class="form-card-content">
        <div class="layout-horizontal-split">
          <div class="layout-horizontal-split-left">
            <div *ngIf="isEdit" class="space-t-l">
              <mat-chip disableRipple [disabled]="true">ID : {{ pack.key }}</mat-chip>
            </div>
            <div class="title selected">
              <div class="title-number">1</div>
              <h1 class="title-text">
                {{ 'DOMAIN' | translate }}
              </h1>
            </div>
            <mat-form-field class="form-field-xl margin-input" appearance="fill">
              <mat-label>{{ 'DOMAIN' | translate }}</mat-label>
              <mat-select
                [disabled]="isEdit"
                formControlName="domain"
                id="PacksNewDomainBtn"
                (selectionChange)="selectDomain(formPack.controls.domain.value)"
                required
              >
                <div id="PacksNewDomainLst">
                  <mat-option *ngFor="let domain of domainsList | sortBy: 'translatedName'" [value]="domain.key">
                    {{ domain.translatedName }}
                  </mat-option>
                </div>
              </mat-select>
            </mat-form-field>

            <div class="title {{ formPack.controls.domain.value ? 'selected' : '' }}">
              <div class="title-number">2</div>
              <h1 class="title-text">
                {{ 'MARKET' | translate }}
              </h1>
            </div>
            <ng-container *ngIf="formPack.controls.domain.value || isEdit">
              <mat-form-field class="form-field-xl margin-input" appearance="fill">
                <mat-label>{{ 'MARKET' | translate }}</mat-label>
                <mat-select
                  [disabled]="isEdit"
                  id="PacksNewMarketBtn"
                  formControlName="market"
                  (selectionChange)="selectMarket(formPack.controls.market.value)"
                  required
                >
                  <div id="PacksNewMarketLst">
                    <mat-option *ngFor="let market of marketsList | sortBy: 'translatedName'" [value]="market.key">
                      {{ market.translatedName }}
                    </mat-option>
                  </div>
                </mat-select>
              </mat-form-field>
            </ng-container>

            <div class="title {{ formPack.controls.market.value ? 'selected' : '' }}">
              <div class="title-number">3</div>
              <h1 class="title-text">
                {{ 'LANGUAGE' | translate }}
              </h1>
            </div>
            <div class="form-field-xl margin-input space-v-l" *ngIf="formPack.controls.market.value">
              <ng-container *ngFor="let language of languagesList | sortBy: 'translatedName'; let index = index">
                <button
                  id="PacksNewLangBtn{{ index }}"
                  [disabled]="isEdit"
                  mat-raised-button
                  type="button"
                  class="btn-select"
                  (click)="formPack.controls.lang.setValue(language.key); selectLanguage(formPack.controls.lang.value)"
                  [ngClass]="formPack.controls.lang.value == language.key ? 'btn-select-selected' : ''"
                >
                  {{ language.translatedName }}
                </button>
              </ng-container>
            </div>
          </div>
          <div class="layout-horizontal-split-right">
            <div id="PacksModifyPackBtn" class="title {{ formPack.controls.lang.value ? 'selected' : '' }}">
              <div class="title-number">4</div>
              <h1 class="title-text">
                {{ 'CONTENTS.PACK.PROPERTIES' | translate }}
              </h1>
            </div>
            <ng-container *ngIf="formPack.controls.lang.value" [formGroup]="formPack">
              <mat-form-field class="form-field-xl margin-input space-h-l" appearance="fill">
                <mat-label>{{ 'TITLE' | translate }}</mat-label>
                <input matInput id="PacksNewTitleTxt" formControlName="title" required />
              </mat-form-field>
              <ng-container *ngTemplateOutlet="commonFormFields"></ng-container>
            </ng-container>
          </div>
        </div>
      </mat-card-content>
    </div>
  </mat-card>

  <!-- targetsDomain -->
  <div *ngIf="isEdit" class="domain-list">
    <app-pack-target-domains #packTargetDomainsComponent [pack]="pack" [referenceType]="'packs'" [targetDomains]="targetDomains">
    </app-pack-target-domains>
  </div>
</div>

<ng-template #commonFormFields [formGroup]="formPack">
  <br />
  <div style="display: flex; flex-direction: row; justify-content: space-between">
    <!-- Publication Date -->
    <app-date-publication-input-form-component
      [form]="formPack"
      dateStartFormControlLabel="publicationStartDate"
      dateEndFormControlLabel="publicationEndDate"
    >
    </app-date-publication-input-form-component>

    <!-- isPremium in edit mode -->
    <div *ngIf="isEdit" style="margin-right: 32px">
      <div class="margin-input">
        <mat-checkbox formControlName="isPremium" class="mt-2">{{ 'IS_PREMIUM' | translate }}</mat-checkbox>
      </div>
    </div>
  </div>

  <!-- isPremium in creation mode -->
  <div class="margin-input" *ngIf="!isEdit">
    <mat-checkbox id="PacksNewPayedChkBox" formControlName="isPremium" class="mt-2">{{ 'IS_PREMIUM' | translate }} </mat-checkbox>
  </div>
  <br />

  <!-- description -->
  <mat-form-field class="margin-input space-h-l form-field-xl" style="width: 100%" appearance="fill">
    <mat-label>{{ 'DESCRIPTION' | translate }}</mat-label>
    <textarea matInput id="PacksNewDescTxt" formControlName="description" rows="3" style="width: 100%"></textarea>
  </mat-form-field>
</ng-template>

<ng-template #editTemplate>
  <mat-card-content>
    <mat-card class="form-card" [formGroup]="formPack">
      <div style="display: flex; margin-bottom: 20px">
        <app-media-upload
          [usePlaceHolderPicture]="true"
          [withUrlInput]="true"
          [formControl]="toControl(formPack.controls.resourceMedias)"
          [width]="200"
          [height]="120"
          [singleImage]="true"
        ></app-media-upload>
        <div class="space-l-s space-r-m">
          <div
            matTooltip="{{ 'CLICK_EDIT' | translate }}"
            class="title d-flex flex-row cursor-pointer"
            style="align-items: center"
            (click)="editTitles()"
            id="PacksModifyTitleModifyBtn"
          >
            <h1 id="PackModfiyTitleTxt">{{ formPack.controls.title.value }}</h1>
            <div><i class="fas fa-pen space-l-s" aria-hidden="true"></i></div>
          </div>
          <mat-chip-set>
            <mat-chip id="PacksModifyIdLbl">{{ 'PACK' | translate }}: {{ pack.key }}</mat-chip>
            <mat-chip id="PacksModifDomainLbl">{{ getName(formPack.controls.domain.value, domainsList) }} </mat-chip>
            <mat-chip id="PacksModifyMarketLbl">{{ getName(formPack.controls.market.value, marketsList) }} </mat-chip>
            <mat-chip id="PacksModifyLangLbl">{{ getName(formPack.controls.lang.value, languagesList) }} </mat-chip>
          </mat-chip-set>
        </div>
      </div>
    </mat-card>
    <mat-tab-group class="invisible-headers" style="margin: 16px">
      <mat-tab>
        <div class="variant-header-container variant-saved" *ngIf="formPack">
          <span class="left-part">
            <!-- status drop-down -->
            <mat-form-field appearance="fill" [formGroup]="formPack" class="space-h-l">
              <mat-label>{{ 'STATUS_PACK' | translate }}</mat-label>
              <mat-select id="PacksModifyStatusBtn" formControlName="status">
                <ng-container *ngFor="let status of statusesList">
                  <div id="PacksModifyStatusLst">
                    <mat-option [value]="status.key" [disabled]="isOptionPublishedDisabled(status.key)">{{
                      (status | translateReference)?.translatedName
                    }}</mat-option>
                  </div>
                </ng-container>
              </mat-select>
            </mat-form-field>

            <span [matMenuTriggerFor]="history" class="history-menu-trigger space-h-l">
              <span class="space-h-m">
                {{ 'MODIFIED_ON' | translate }} {{ pack.modificationDate | date: 'dd/MM/yyyy HH:mm' }}
                <ng-container *ngIf="pack.modifier">
                  <br />
                  {{ 'BY' | translate }} {{ pack.modifier }}
                </ng-container>
              </span>
              <div class="mat-select-arrow-wrapper"><div class="mat-select-arrow"></div></div>
            </span>
          </span>
          <span class="right-part">
            <ng-container *ngIf="isEdit" [formGroup]="formPack">
              <mat-form-field class="form-field-xl margin-input" appearance="fill">
                <mat-label>{{ 'TYPE' | translate }}</mat-label>
                <mat-select id="PacksModifyTypeBtn" formControlName="type" required>
                  <div id="PacksModifyTypeLst">
                    <mat-option *ngFor="let type of packTypeList | sortBy: 'translatedName'" [value]="type.key">
                      {{ type.translatedName }}
                    </mat-option>
                  </div>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </span>
        </div>
      </mat-tab>
    </mat-tab-group>
    <mat-menu #history="matMenu">
      <span mat-menu-item disabled *ngIf="pack.modificationDate || pack.modifier">
        <ng-container *ngIf="pack.modificationDate">
          {{ 'MODIFIED_ON' | translate }} {{ pack.modificationDate | date: 'dd/MM/yyyy HH:mm' }}
        </ng-container>
        -
        <ng-container *ngIf="pack.modifier"> {{ 'BY' | translate }} {{ pack.modifier }} </ng-container>
      </span>
      <mat-divider></mat-divider>
      <mat-divider></mat-divider>
      <span mat-menu-item disabled *ngIf="pack.creationDate || pack.creator">
        <ng-container *ngIf="pack.creationDate">
          {{ 'CREATED_ON' | translate }} {{ pack.creationDate | date: 'dd/MM/yyyy HH:mm' }}
        </ng-container>
        -
        <ng-container *ngIf="pack.creator"> {{ 'BY' | translate }} {{ pack.creator }} </ng-container>
      </span>
    </mat-menu>

    <div style="margin-left: 16px; width: 100%">
      <ng-container *ngTemplateOutlet="commonFormFields"></ng-container>
    </div>
  </mat-card-content>
</ng-template>
